import { useEffect, useState } from "react";

function format(n: number) {
  return n < 10 ? `0${n}` : `${n}`;
}

export default function useClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(t);
  }, []);
  const week = ["日", "一", "二", "三", "四", "五", "六"][now.getDay()];
  return {
    date: `${now.getFullYear()} 年 ${now.getMonth() + 1} 月 ${now.getDate()} 日 · 星期${week}`,
    time: `${format(now.getHours())}:${format(now.getMinutes())}:${format(now.getSeconds())}`,
  };
}